import React from 'react';
import { Link } from 'react-router-dom';
import { UsersThree, ArrowRight } from '@phosphor-icons/react';
import { useI18n } from '../contexts/I18nContext';

// Shared rooms: a room sensor cannot tell residents apart, so movement is shown per room only.
export function SharedRoomNote({ roomId, roomName }) {
  const { t } = useI18n();
  return (
    <div className="bg-white rounded-2xl border border-stone_line p-6 shadow-soft flex items-start gap-4" data-testid="patient-shared-room-note">
      <div className="w-10 h-10 rounded-xl bg-bg-alt text-ink-soft grid place-items-center shrink-0">
        <UsersThree size={20} weight="duotone" />
      </div>
      <div className="min-w-0">
        <h2 className="font-heading text-xl text-ink">{t('mv_title')}</h2>
        <p className="text-sm text-ink-soft mt-1">{t('mv_shared_note')}</p>
        {roomId && (
          <Link to={`/rooms/${roomId}`} data-testid="patient-shared-room-link"
            className="inline-flex items-center gap-1.5 text-sm text-sage-700 hover:text-sage-600 mt-3">
            {t('mv_shared_link', { room: roomName || '' })} <ArrowRight size={14} />
          </Link>
        )}
      </div>
    </div>
  );
}
